import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=65854245&scoped=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=65854245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65854245",
  null
  
)

export default component.exports